import React, { useState, useEffect } from "react";
import ReportDataForm from "./ReportDataForm";
import { Paper, withStyles, CircularProgress, Dialog } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/reportDataActions";
import History from "../../../History";
import { parseURL } from "../../sc-utilities";
import AppLogoLoading from '../../sc-logo';
import { enqueueSnackbar } from "../../np-dashboard/Notifier/store/notifierActions";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    logo: {
        width: "250px",
        margin: "10px"
    }

});

const ReportDataEdit = props => {
    const { classes, reportData, loading, activeCustomer, translations, onFetchReportData, onFetchLogos, onEditReportData, permissions, onFetchCustomer } = props;
    const [data, setData] = useState({ data: true, logos: [] });
    const [customerAddress, setCustomerAddress] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            await onFetchReportData({ ReportDataID: parseURL(window.location.href).reportDataID, ActiveCustomerID: activeCustomer?.CustomerID });

            let logos = await onFetchLogos({ ActiveCustomerID: activeCustomer?.CustomerID });
            logos = [{ value: -1, displayValue: translations['none'] || 'None', imageLocation: '' }, ...logos]
            setData({ data: false, logos: logos });
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        data['ReportDataID'] = reportData.ReportDataID;
        if (data.LogoID === -1) {
            data.LogoID = null
        }
        if (data.CompanyName.length > 60) {
            enqueueSnackbar({
                message: `Company name should not be longer than 180 characters`,
                options: {
                    variant: "warning"
                }
            });
        }
        let result = await onEditReportData({ ...data, ActiveCustomerID: activeCustomer?.CustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: reportData && reportData['Name'] ? reportData['Name'] : "",
        CompanyName: reportData && reportData['CompanyName'] ? reportData['CompanyName'] : "",
        Address: reportData && reportData['Address'] ? reportData['Address'] : '',
        IncludePerformedDiagnoseCasesOnly: !!reportData?.IncludePerformedDiagnoseCasesOnly,
        AddPhotosToErasureReports: !!reportData?.AddPhotosToErasureReports,
        ErasureReportPhotosLayout: reportData?.ErasureReportPhotosLayout,
        AddPhotosToDiagnoseReports: !!reportData?.AddPhotosToDiagnoseReports,
        DiagnoseReportPhotosLayout: reportData?.DiagnoseReportPhotosLayout,
        AddPhotosToVerificationReports: !!reportData?.AddPhotosToVerificationReports,
        VerificationReportPhotosLayout: reportData?.VerificationReportPhotosLayout,
        LogoID: reportData && reportData['LogoID'] ? reportData['LogoID'] : '',
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            CompanyName: Yup.string().required("Required"),
            Address: Yup.string().required("Required"),
            LogoID: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_report_data"] || "Edit report data",
        ButtonSubmit: hasPermission(permissions, "report_data_save") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null,
    };

    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.data}
                PaperProps={{
                    classes: {
                        root: classes.submit
                    }
                }}
            >
                <AppLogoLoading />
            </Dialog>
            {!data.data ?
                <ReportDataForm
                    formSettings={formSettings}
                    initialValues={initialValues}
                    logos={data.logos}
                    handleSubmit={handleSubmit}
                    loading={loading}
                    translations={translations}
                />
                : <CircularProgress
                    variant="static"
                    color="primary"
                    size={28}
                />}
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer ?? null,
        permissions: state?.core?.login?.permissions || [],
        reportData: state.setting.reportData && state.setting.reportData.loaded ? state.setting.reportData.loaded : {},
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchLogos: (id) => dispatch(actions.fetchLogos(id)),
        onEditReportData: ReportData => dispatch(actions.editReportData(ReportData)),
        onFetchReportData: reportData => dispatch(actions.loadReportData(reportData)),
        onFetchCustomer: (params) => dispatch(actions.fetchCustomer(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ReportDataEdit));